module.exports = "<app-resolve promise=\"$ctrl.$promise\">\r\n  <div class=\"margin-md\">\r\n    <contabilidad-buscarimportes-lista-item ng-repeat=\"item in $ctrl.data\"\r\n        ng-if=\"$ctrl.data.length > 0\"\r\n        data=\"item\"\r\n    ></contabilidad-buscarimportes-lista-item>\r\n    <p class=\"info\"\r\n        ng-if=\"$ctrl.data.length == 0\">No se encontraron resultados</p>\r\n  </div>\r\n</app-resolve>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/buscarimportes/components/lista/template.html
// module id = 1692
// module chunks = 0